import { useEffect } from 'react';
import { useNextMicro, useForceUpdate } from '@okee-uikit/react-hooks';
import { useUpload } from './useUpload';
export function useFilesUpdate() {
  var fileUpload = useUpload();
  var update = useNextMicro(useForceUpdate());
  useEffect(function () {
    var destroy = function destroy() {
      fileUpload.removeListener('files-change', update);
    };

    fileUpload.addListener('files-change', update);
    return destroy;
  }, []);
}